import { createSelector } from 'reselect'
import { Map } from 'immutable'

import { gallerySearch } from 'helpers/fuzzySearch'

export const getGallery = (state: Map<any, any>) => state.get('gallery')

export const getGalleryLazyLoaded = createSelector(getGallery, gallery => gallery.get('lazyLoaded'))

export const getGalleryPending = createSelector(getGallery, gallery => gallery.get('pending'))

export const getGallerySearchBy = createSelector(getGallery, gallery => gallery.get('search'))

export const getGalleryImages = createSelector(getGallery, gallery => gallery.get('images'))

export const getGalleryActivitiesImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('activities') !== -1)
)

export const getGalleryEmailsImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('emails') !== -1).slice(0, lazyLoaded)
)

export const getGalleryPublicImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('public') !== -1).slice(0, lazyLoaded)
)

export const getGallerySprintsImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('sprints') !== -1).slice(0, lazyLoaded)
)

export const getSearchAtGalleryEmailsImages = createSelector(
  getGalleryImages,
  getGallerySearchBy,
  (images, filterBy) => {
    const imagesSearch = images.filter((image: Map<string, any>) => image.get('url').indexOf('emails') !== -1)
    return gallerySearch(imagesSearch, filterBy)
  }
)

export const getSearchAtGalleryOrganizationsImages = createSelector(
  getGalleryImages,
  getGallerySearchBy,
  (images, filterBy) => {
    const imagesSearch = images.filter((image: Map<string, any>) => image.get('url').indexOf('organizations') !== -1)
    return gallerySearch(imagesSearch, filterBy)
  }
)

export const getSearchAtGalleryProtracksImages = createSelector(
  getGalleryImages,
  getGallerySearchBy,
  (images, filterBy) => {
    const imagesSearch = images.filter((image: Map<string, any>) => image.get('url').indexOf('protracks') !== -1)
    return gallerySearch(imagesSearch, filterBy)
  }
)

export const getSearchAtActivitiesImages = createSelector(getGalleryImages, getGallerySearchBy, (images, filterBy) => {
  const imagesSearch = images.filter((image: Map<string, any>) => image.get('url').indexOf('activities') !== -1)
  return gallerySearch(imagesSearch, filterBy)
})

export const getGalleryLoaded = createSelector(getGallery, gallery => gallery.get('loaded'))

export const getImageForReplace = createSelector(getGallery, gallery => gallery.get('imageForReplace'))

export const getIsButtonDisable = createSelector(getGallery, gallery => gallery.get('isButtonDisable'))

export const getImageToDelete = createSelector(getGallery, gallery => gallery.get('imageToDelete'))

export const getUsagePlacesForDeletedImage = createSelector(
  [
    getSearchAtGalleryProtracksImages,
    getSearchAtGalleryEmailsImages,
    getSearchAtGalleryOrganizationsImages,
    getSearchAtActivitiesImages,
    getImageToDelete,
  ],
  (protracks, emails, organizations, activities, image) => {
    const all = [...protracks, ...emails, ...organizations, ...activities]
    return all.find((item: Map<string, any>) => item.get('url') === image).get('usagePlaces')
  }
)
